import { Link } from '@tanstack/react-router';
import { Flex, Layout, Typography } from 'antd';

import { ROUTE_PATHS } from '@modules/route-paths';

import FooterLinks from './components/footer-links';
import {
  INTELLECTUAL_PROPERTY_NOTICES,
  currentYear,
  helpLinks,
  styles,
  supportLinks,
} from './shared';

const AppFooter = () => (
  <Layout.Footer className={styles.footer}>
    <div className={styles.content}>
      <Flex className={styles.brand} gap={8} vertical>
        <Typography.Text strong>NexoTCG</Typography.Text>
        <Typography.Text type="secondary">
          Marketplace para jogadores, colecionadores e lojas encontrarem a carta
          certa com mais clareza e segurança.
        </Typography.Text>
      </Flex>
      <FooterLinks title="Ajuda" links={helpLinks} />
      <FooterLinks title="Suporte" links={supportLinks} />
      <Flex className={styles.legalNotice} gap={8} vertical>
        <Typography.Text type="secondary">
          NexoTCG © {currentYear}. Todos os direitos reservados.
        </Typography.Text>
        {INTELLECTUAL_PROPERTY_NOTICES.map(
          ({ rightsNotice, independenceNotice, imagePurposeNotice }) => (
            <Typography.Text key={rightsNotice} type="secondary">
              {rightsNotice} {independenceNotice} {imagePurposeNotice}
            </Typography.Text>
          ),
        )}
        <Link
          className={styles.legalLink}
          to={ROUTE_PATHS.INTELLECTUAL_PROPERTY}
        >
          Propriedade Intelectual
        </Link>
      </Flex>
      <Flex className={styles.bottom} justify="space-between" gap={16} wrap>
        <Typography.Text type="secondary">
          NexoTCG — conectando o universo dos card games.
        </Typography.Text>
      </Flex>
    </div>
  </Layout.Footer>
);

export default AppFooter;
